import { createCoreMethod } from '../../utils/createCoreMethod';

export const removeImage = createCoreMethod(
  'removeImage',
  async (nodeId: string) => {
    try {
      const nodeName = `Heatmap - ${nodeId}`;

      const currentNode = figma.currentPage.children.find(
        (node) => node.name === nodeName
      );

      if (currentNode) {
        currentNode.remove();
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Removing image error', e);
    }
  }
);
